import React, { useContext, useEffect, useState } from "react";

import { SCOPE_OF_WORK } from "../constants/editor";
import { EditorContext } from "../containers/editor/EditorLayout";

const useScopeOfWorkEvent = () => {
  let { metadata, widgets, updateWidgets } = useContext(EditorContext);

  const calculateTotalTime = tableConfigData => {
    let newTableConfig = { ...tableConfigData };
    let minHour = 0;

    newTableConfig.sections?.forEach(section => {
      section.items?.forEach(val => {
        if (val.active && parseFloat(val.data.estimated)) {
          minHour += parseFloat(val.data.estimated);
        }
      });
    });
    const total = Number(minHour.toFixed(1));
    return total;
  };

  const handleScopeOfWorkOptionClick = event => {
    let tableConfig = document.getElementById(metadata.activeWidgetId).getAttribute("data-table-config");
    tableConfig = JSON.parse(tableConfig);
    let target = getClosestSiblingWithSelector(event.target, "input");
    if(!target) return;
    let targetId = target.getAttribute("id");
    let updatedTableConfig;
    let sectionIndex;
    let checked;

    if (target.classList.contains("scope-of-work-item-input")) {
      sectionIndex = targetId.split("-")[3];
      let itemIndex = targetId.split("-")[4];
      let itemType = targetId.split("-")[2] === "itemcheckbox" ? "checkbox" : "radio";

      if (itemType === "checkbox") {
        let isChecked = document.getElementById(targetId).checked;
        checked = isChecked;
        if (isChecked) document.getElementById(targetId).removeAttribute("checked");
        else document.getElementById(targetId).setAttribute("checked", "");
        document.getElementById(targetId).checked = !isChecked;
      } else {
        let activeSection = document.getElementById(targetId).closest(".card-body");
        activeSection.querySelectorAll(".scope-of-work-item-input").forEach(element => {
          element.checked = false;
          element.removeAttribute("checked");
        });
        document.getElementById(targetId).checked = true;
        document.getElementById(targetId).setAttribute("checked", "");
      }
      document.getElementById(metadata.activeWidgetId).querySelectorAll(".scope-of-work-item-input").forEach(element => {
        if (!element.checked)
          element
            .closest("ul")
            .querySelector(".item-amount-details .scope-of-work-estimated-time")
            .classList.add("disable");
        else
          element
            .closest("ul")
            .querySelector(".item-amount-details .scope-of-work-estimated-time")
            .classList.remove("disable");
      });

      sectionIndex = Number(sectionIndex.slice(1));
      itemIndex = Number(itemIndex.slice(1));

      updatedTableConfig = {
        ...tableConfig,
        sections: tableConfig.sections.map((section, sIdx) => {
          if (sIdx !== sectionIndex) return section;
          return {
            ...section,
            items: section.items.map((item, iIdx) => {
              if (itemType === "checkbox") {
                return iIdx === itemIndex ? { ...item, active: !checked } : item;
              } else {
                return { ...item, active: iIdx === itemIndex };
              }
            }),
          };
        }),
      };
    }

    let total = calculateTotalTime(updatedTableConfig);

    if (document.querySelector(`#${metadata.activeWidgetId} .total-estimated-show`))
      document.querySelector(`#${metadata.activeWidgetId} .total-estimated-show`).innerHTML = `${total} Hours`;

    let targetWidgetIndex = widgets.findIndex(widget => widget.id === metadata.activeWidgetId[0]);
    let newArray = Object.assign([...widgets]);
    newArray = Object.assign([...newArray], {
      [targetWidgetIndex]: {
        ...newArray[targetWidgetIndex],
        style: {
          ...newArray[targetWidgetIndex].style,
          height: document.getElementById(metadata.activeWidgetId).style.height,
        },
        data: {
          ...newArray[targetWidgetIndex].data,
          "data-table-config": JSON.stringify(updatedTableConfig),
        },
        innerHTML: document.getElementById(metadata.activeWidgetId[0]).innerHTML,
      },
    });
    updateWidgets(newArray);
  };

  const getClosestSiblingWithSelector = (elem, selector) => {
    let prev = elem.previousElementSibling;
    let next = elem.nextElementSibling;

    while (prev || next) {
      if (prev && prev.matches(selector)) return prev;
      if (next && next.matches(selector)) return next;

      prev = prev?.previousElementSibling || null;
      next = next?.nextElementSibling || null;
    }

    return null; // No match found
  };

  useEffect(() => {
    if (metadata.activeWidgetType[0] !== SCOPE_OF_WORK || document.querySelector(".scope-of-work-modal")) return;

    const checkBoxElem = document.querySelectorAll(".custom-checkbox");
    checkBoxElem.forEach(el => {
      el.addEventListener("click", handleScopeOfWorkOptionClick);
    });

    return () => {
      checkBoxElem.forEach(el => {
        el.removeEventListener("click", handleScopeOfWorkOptionClick);
      });
    };
  });
};

export default useScopeOfWorkEvent;
